import { render } from "./SenmetsuPage.vue?vue&type=template&id=1ce8e78a"
import script from "./SenmetsuPage.vue?vue&type=script&lang=js"
export * from "./SenmetsuPage.vue?vue&type=script&lang=js"

import "./SenmetsuPage.vue?vue&type=style&index=0&id=1ce8e78a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__